import * as React from 'react'
import {useMemo, useState} from 'react'
import {Lang} from 'yougile-lang'
import {DataObjectId, MoveTaskToColWhenDone} from 'yougile-model'
import {Sync} from '@client/sync'
import {CheckboxNew} from '@components/common/base/checkbox-new/checkbox-new'
import {Dropdown} from '@components/common/dropdown/dropdown'
import {ProjectsFlatTreeDropdownContent} from '@components/common/projects-tree/projects-tree'
import {Link} from '@components/sticker/my-stickers/common/add-link/add-link'
import {PathToCol} from './path-to-col'

interface Props {
  setValue: (value: MoveTaskToColWhenDone) => void
  onClick: () => void
  data?: MoveTaskToColWhenDone
  label: string
  hintLabel?: string
}

export const MoveTaskToColCheckbox = (props: Props) => {
  const {setValue, onClick, data, label, hintLabel} = props

  const [show, setShow] = useState(false)

  const chooseLocation = (value: DataObjectId) => {
    setValue({checked: true, value})
    setShow(false)
  }

  const {value: hubId, checked} = data || {}

  const hub = useMemo(() => {
    if (!hubId) {
      return undefined
    }
    const hub = Sync.getCurrentSandbox().getHub(hubId)
    if (hub?.deleted) {
      return undefined
    }
    return hub
  }, [hubId])

  const onClickShow: React.MouseEventHandler<HTMLDivElement> = e => {
    e.stopPropagation()
    setShow(true)
  }

  return (
    <div className={'mb-16'}>
      <CheckboxNew
        value={Boolean(checked)}
        onChange={onClick}
        label={label}
        footnote={
          <div>
            {hintLabel && <span>{hintLabel}</span>}

            {checked && (
              <Dropdown
                visible={show}
                onVisibleChange={() => setShow(false)}
                content={
                  <ProjectsFlatTreeDropdownContent onChange={chooseLocation} />
                }
              >
                <div onClick={onClickShow}>
                  <PathToCol hub={hub} />
                  {!hub && <Link>{Lang.msg.board.selectColumn}</Link>}
                </div>
              </Dropdown>
            )}
          </div>
        }
      />
    </div>
  )
}
